import React from 'react';
import { Typography, useTheme } from '@methanesat/ui-components';
import { SHOW_FEATURE_IDS } from '../../../../environmentVariables';

export type FeatureIDCaptionProps = {
    caption?: string;
};

/**
 * Displays the feature IDs for debugging purposes
 */
export const FeatureIDCaption = ({ caption }: FeatureIDCaptionProps) => {
    const theme = useTheme();

    if (SHOW_FEATURE_IDS && caption) {
        return (
            <Typography
                variant="caption"
                color={theme.palette.grey[400]}
                sx={{
                    lineHeight: '0.8rem',
                    textAlign: 'right',
                    width: '100%',
                    display: 'block',
                    whiteSpace: 'break-spaces'
                }}
            >
                {caption}
            </Typography>
        );
    }
};
